(function (app) {

    app.provider("transactionApi",
        [
            function () {
                this.$get = [
                    "complianceHubApiGateway", "complianceHubBaseApiUrl", function (complianceHubApiGateway, complianceHubBaseApiUrl) {
                        var service = {};

                        //GETs
                        service.get = function (transactionId) {
                            return complianceHubApiGateway.get("/Transactions/" + transactionId);
                        };

                        service.getSummaryUrl = function (transactionId) {
                            return complianceHubBaseApiUrl + "/Transactions/" + transactionId + "/Summary";
                        };

                        service.getSummary = function(transactionId) {
                            return complianceHubApiGateway.getFile("/Transactions/" + transactionId + "/Summary", { headers: { "Accept": "application/pdf" } });
                        };
                        
                        service.getSummaryExists = function(transactionId) {
                            return complianceHubApiGateway.get("/Transactions/" + transactionId + "/SummaryExists");
                        };

                        service.getTransactionsForUser = function () {
                            return complianceHubApiGateway.getArray("/Transactions/User");
                        };

                        service.getTransactionDocuments = function (transactionId) {
                            return complianceHubApiGateway.getArray("/Transactions/" + transactionId + "/Documents");
                        };

                        service.getTransactionDocument = function (transactionId, fileName) {
                            return complianceHubApiGateway.getFile("/Transactions/" + transactionId + "/Documents/" + fileName, { headers: { "Accept": "application/pdf" } });
                        };

                        service.getDisclosures = function (transactionId) {
                            return complianceHubApiGateway.getArray("/Transactions/" + transactionId + "/Disclosures");
                        };

                        service.getDisclosure = function (transactionId, disclosureId) {
                            return complianceHubApiGateway.getFile("/Transactions/" + transactionId + "/Disclosures/" + disclosureId, { headers: { "Accept": "application/pdf" } });
                        };

                        service.getTransactionFromExternalIdentifier = function(externalIdentifier) {
                            return complianceHubApiGateway.get("/Transactions/ForExternalIdentifier/" +
                                externalIdentifier);
                        };

                        service.getTransactionRightBridgeResponse = function(transactionId) {
                            return complianceHubApiGateway.get(
                                "/Transactions/" + transactionId + "/RightBridgeResponse");
                        };

                        service.getTransactionRightBridgeResponseWithDocuments = function (transactionId) {
                            return complianceHubApiGateway.get(
                                "/Transactions/" + transactionId + "/RightBridgeResponse/Documents");
                        };
                     
                        service.getRightBridgeTransactionDocumentUrl = function (transactionId, rightBridgeResponseId, fileName) {
                            return complianceHubBaseApiUrl + "/Transactions/" + transactionId + "/RightBridgeResponse/" + rightBridgeResponseId + "/Documents/" + fileName;
                        };
                       
                        service.getTransactionRetireUpResponse = function(transactionId) {
                            return complianceHubApiGateway.get("/Transactions/" + transactionId + "/RetireUpResponse");
                        };

                        service.getRetireUpTransactionDocumentUrl = function (transactionId, retireUpResponseId, fileName) {                           
                            return complianceHubBaseApiUrl + "/Transactions/ " + transactionId + " /RetireUpResponse/ " + retireUpResponseId + "/Documents/" + fileName;
                        };

                        service.getRetireUpTransactionDocument = function (transactionId, retireUpResponseId, fileName) {
                            return complianceHubApiGateway.getFile("/Transactions/" + transactionId + "/RetireUpResponse/" + retireUpResponseId + "/Documents/" + fileName,
                                { headers: { "Accept": "application/pdf" } });
                        };

                        service.getAuditLogFileUrl = function (transactionId) {
                            return complianceHubBaseApiUrl + "/Transactions/" + transactionId + "/AuditLogFile";
                        };

                        service.getAuditLogFile = function (transactionId) {
                            return complianceHubApiGateway.getFile("/Transactions/" + transactionId + "/AuditLogFile", { headers: { "Accept": "application/pdf" } });
                        };

                        service.getAuditLogFileExists = function (transactionId) {
                            return complianceHubApiGateway.get("/Transactions/" + transactionId + "/AuditLogFileExists");
                        };

                        //PUTs
                        service.updateTransactionDocument = function (transactionId, documentId, document) {
                            return complianceHubApiGateway.putFile("/Transactions/" + transactionId + "/Documents/" + documentId, document);
                        };

                        service.updateCompletedOptionalForms = function(transactionId, transaction) {
                            return complianceHubApiGateway.put("/Transactions/" + transactionId + "/OptionalForms",
                                transaction);
                        };

                        service.updateTransactionStatus = function (transactionId, transaction) {
                            return complianceHubApiGateway.put("/Transactions/" + transactionId, transaction);
                        };

                        service.updateLastTransactionStage = function (transactionId, transaction) {
                            return complianceHubApiGateway.put("/Transactions/" + transactionId + "/LastStage", transaction);
                        };

                        service.updateTransactionProduct = function (transactionId, transaction) {
                            return complianceHubApiGateway.put("/Transactions/" + transactionId + "/Product", transaction);
                        };

                        service.updateJurisdiction = function (transactionId, transaction) {
                            return complianceHubApiGateway.put("/Transactions/" + transactionId + "/Jurisdiction", transaction);
                        };

                        service.updateTransactionAppStatus = function(transactionId, transaction) {
                            return complianceHubApiGateway.put("/Transactions/" + transactionId + "/UpdateAppStatus",
                                transaction);
                        };

                        //service.updateRightBridgeResponse = function (transactionId, transaction) {
                        //    return complianceHubApiGateway.put("/Transactions/" + transactionId + "/RightBridgeResponse", transaction);
                        //}



                        //POSTs
                        service.add = function (transaction) {
                            return complianceHubApiGateway.post("/Transactions", transaction);
                        };

                        service.addTransactionDocument = function (transactionId, requiredDocumentName, document) {
                            return complianceHubApiGateway.postFile("/Transactions/" + transactionId + "/Documents/" + requiredDocumentName, document);
                        };

                        //DELETEs

                        return service;
                    }
                ];
            }
        ]);

})(window.app);